

















import { Vue, Component, Prop } from "vue-property-decorator";
import { sendVerificationSms, sendPhoneRegisterSms } from '@/services/loginManager';
import { replace } from 'ramda';
import { AxiosError } from "axios";
import { isErrorType } from '@/services/errorHandling';
import { DroppoErrors } from "@/constants/errors";


@Component({
  name: "InfoSaveMoney",
  components: {
  },
})
export default class InfoSaveMoney extends Vue {
  private close() {
    this.$emit("dialog:clickClose");
  }
}
